import { CountProductPage, fieldsAuto, FilterTemplates, ParamsType, PartConnectionTemplate } from '@entities/Filter/module/types/filterSchema';
import { FilterParams } from '@entities/Filter';

export const convertorParams = (params: ParamsType): string => {
  return Object.keys(params)
    .filter(
      param =>
        (!!params[param] || params[param] === 0) &&
        !([FilterParams.Axis, fieldsAuto.Mark, fieldsAuto.Model, fieldsAuto.Year, fieldsAuto.Modification] as string[]).includes(param),
    )
    .map(param => {
      if (Array.isArray(params[param])) {
        return params[param].map(value => `${param}[]=${value}`).join('&');
      } else {
        return `${param}=${params[param]}`;
      }
    })
    .join('&');
};

export const generateStrParams = (
  params: ParamsType,
  template: FilterTemplates,
  currentPage: number,
): {
  shortStrParams: string;
  strParams: string;
} => {
  const stringGetParams = convertorParams(params);
  const arraySubString = [`?part=${PartConnectionTemplate[template]}`, stringGetParams, `perpage=${CountProductPage(template)}`];

  return {
    shortStrParams: arraySubString.join('&'),
    strParams: [...arraySubString, `page=${currentPage}`].join('&'),
  };
};
